module.exports = __webpack_public_path__ + "static/media/3.ab5a9e3b.JPG";